import * as Yup from "yup";

const page5Schema = Yup.object().shape({
});

export default page5Schema;
